"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WATCH_STORAGE_KEY = 'da-ddt.watched';
exports.BrowserStorage = {
    loadList: function () {
        if (typeof localStorage === 'undefined') {
            return [];
        }
        var stored;
        try {
            stored = localStorage.getItem(WATCH_STORAGE_KEY);
        }
        catch (e) {
            return [];
        }
        if (!stored) {
            return [];
        }
        return stored.split(',');
    },
    saveList: function (list) {
        if (typeof localStorage === 'undefined') {
            return;
        }
        var toStore = list.join(',');
        localStorage.setItem(WATCH_STORAGE_KEY, toStore);
    },
};
//# sourceMappingURL=storage.js.map